var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-card',{staticClass:"mt-16",attrs:{"min-width":"400"}},[_c('v-card-text',[_c('AuthForm')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }